import React from 'react';

export const CurtainCeilingMount = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 91" {...props}>
      <path fill="#fff" d="M4.9 19.7h86.3v61.1H4.9z" />
      <path
        d="M91.1 81.3H4.9c-.3 0-.5-.2-.5-.5V19.7c0-.3.2-.5.5-.5h86.3c.3 0 .5.2.5.5v61.1c0 .2-.3.5-.6.5zM5.4 80.2h85.2v-60H5.4v60z"
        fill="#dcd9d5"
      />
      <path fill="#fff" d="M4.9 19.7h86.3v61.1H4.9z" />
      <path
        d="M91.1 81.3H4.9c-.3 0-.5-.2-.5-.5V19.7c0-.3.2-.5.5-.5h86.3c.3 0 .5.2.5.5v61.1c0 .2-.3.5-.6.5zM5.4 80.2h85.2v-60H5.4v60z"
        fill="#dcd9d5"
      />
      <g fill="#dcd9d5">
        <path d="M8.9 23.7h78.2v53H8.9z" />
        <path d="M87.1 77.2H8.9c-.3 0-.5-.2-.5-.5v-53c0-.3.2-.5.5-.5h78.2c.3 0 .5.2.5.5v53c.1.3-.2.5-.5.5zm-77.7-1h77.1v-52H9.4v52z" />
      </g>
      <path
        d="M95.5 81.2H.5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h95c.3 0 .5.2.5.5s-.2.5-.5.5z"
        fill="#dcd9d5"
      />
      <g>
        <path fill="#233762" d="M.5.4h95v2.4H.5z" />
        <path d="M95.8 3.1H.2v-3h95.6v3zm-95-.6h94.4V.7H.8v1.8z" fill="#fff" />
        <path
          fill="#233762"
          stroke="#fff"
          strokeWidth={0.657}
          strokeMiterlimit={10}
          d="M4.3 88V.3h34.2V88"
        />
        <path
          fill="#233762"
          stroke="#fff"
          strokeWidth={0.695}
          strokeMiterlimit={10}
          d="M12.9 88V10.2M21.4 88V10.2M29.9 88V10.2"
        />
        <path
          d="M4.3 87.9c2.1 0 2.1 2.6 4.3 2.6 2.1 0 2.1-2.6 4.3-2.6 2.1 0 2.1 2.6 4.3 2.6 2.1 0 2.1-2.6 4.3-2.6 2.1 0 2.1 2.6 4.3 2.6 2.1 0 2.1-2.6 4.3-2.6 2.1 0 2.1 2.6 4.3 2.6 2.1 0 2.1-2.6 4.3-2.6"
          fill="#233762"
        />
        <path
          d="M4.3 87.9c2.1 0 2.1 2.6 4.3 2.6 2.1 0 2.1-2.6 4.3-2.6 2.1 0 2.1 2.6 4.3 2.6 2.1 0 2.1-2.6 4.3-2.6 2.1 0 2.1 2.6 4.3 2.6 2.1 0 2.1-2.6 4.3-2.6 2.1 0 2.1 2.6 4.3 2.6 2.1 0 2.1-2.6 4.3-2.6"
          fill="none"
          stroke="#fff"
          strokeWidth={0.662}
          strokeMiterlimit={10}
        />
        <g>
          <path
            fill="#233762"
            stroke="#fff"
            strokeWidth={0.678}
            strokeMiterlimit={10}
            d="M55.7 88V.3h36.4V88"
          />
          <path
            fill="#233762"
            stroke="#fff"
            strokeWidth={0.718}
            strokeMiterlimit={10}
            d="M64.8 88V10.2M73.9 88V10.2M83 88V10.2"
          />
          <path
            d="M55.7 87.9c2.3 0 2.3 2.7 4.6 2.7s2.3-2.7 4.6-2.7 2.3 2.7 4.6 2.7 2.3-2.7 4.6-2.7 2.3 2.7 4.6 2.7 2.3-2.7 4.6-2.7 2.3 2.7 4.6 2.7 2.3-2.7 4.6-2.7"
            fill="#233762"
          />
          <path
            d="M55.7 87.9c2.3 0 2.3 2.7 4.6 2.7s2.3-2.7 4.6-2.7 2.3 2.7 4.6 2.7 2.3-2.7 4.6-2.7 2.3 2.7 4.6 2.7 2.3-2.7 4.6-2.7 2.3 2.7 4.6 2.7 2.3-2.7 4.6-2.7"
            fill="none"
            stroke="#fff"
            strokeWidth={0.683}
            strokeMiterlimit={10}
          />
        </g>
      </g>
    </svg>
  );
};
